var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("fieldset", { staticClass: "radio radio_container" }, [
    _vm.legend
      ? _c("legend", [
          _c("span", {
            directives: [
              {
                name: "sanitize",
                rawName: "v-sanitize",
                value: _vm.legend,
                expression: "legend"
              }
            ]
          }),
          _vm._v(" "),
          _vm.legendOption
            ? _c("span", {
                directives: [
                  {
                    name: "sanitize",
                    rawName: "v-sanitize",
                    value: _vm.legendOption,
                    expression: "legendOption"
                  }
                ],
                staticClass: "optional"
              })
            : _vm._e()
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "radio-rating" }, [
      _c(
        "div",
        {
          staticClass: "radio-rating__options",
          class: {
            "radio-rating__options--small": _vm.optionsEnhanced.length > 10
          }
        },
        _vm._l(_vm.optionsEnhanced, function(option, index) {
          return _c(
            "div",
            { key: option.value, staticClass: "radio-rating__option" },
            [
              _c("input", {
                staticClass: "radio-rating__option-input",
                attrs: {
                  type: "radio",
                  id: _vm.uniqueId + "-" + index + "-" + option.value,
                  name: _vm.name,
                  required: _vm.required,
                  disabled: _vm.disabled
                },
                domProps: {
                  value: option.value,
                  checked: option.value === _vm.value
                },
                on: { change: _vm.onChange }
              }),
              _vm._v(" "),
              _c("label", {
                directives: [
                  {
                    name: "sanitize",
                    rawName: "v-sanitize",
                    value: option.label,
                    expression: "option.label"
                  }
                ],
                staticClass: "radio-rating__option-label",
                attrs: { for: _vm.uniqueId + "-" + index + "-" + option.value }
              })
            ]
          )
        }),
        0
      ),
      _vm._v(" "),
      _c("div", { staticClass: "radio-rating__scale" }, [
        _c("div", {
          directives: [
            {
              name: "sanitize",
              rawName: "v-sanitize",
              value: _vm.startScale,
              expression: "startScale"
            }
          ],
          staticClass: "radio-rating__scale-start"
        }),
        _vm._v(" "),
        _c("div", {
          directives: [
            {
              name: "sanitize",
              rawName: "v-sanitize",
              value: _vm.endScale,
              expression: "endScale"
            }
          ],
          staticClass: "radio-rating__scale-end"
        })
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }